import { useTranslation } from "react-i18next";

const FluencyPath = () => {
  const { t } = useTranslation();

  const steps = [
    {
      number: "01",
      title: t("home.fluencyPath.steps.findTutor.title"),
      description: t("home.fluencyPath.steps.findTutor.description"),
    },
    {
      number: "02",
      title: t("home.fluencyPath.steps.liveLessons.title"),
      description: t("home.fluencyPath.steps.liveLessons.description"),
    },
    {
      number: "03",
      title: t("home.fluencyPath.steps.practiceDaily.title"),
      description: t("home.fluencyPath.steps.practiceDaily.description"),
    },
    {
      number: "04",
      title: t("home.fluencyPath.steps.startSpeaking.title"),
      description: t("home.fluencyPath.steps.startSpeaking.description"),
    },
  ];

  return (
    <section id="fluency-path" className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-4">
              {t("home.fluencyPath.title")}
            </h2>
            <p className="text-muted-foreground max-w-xl mx-auto">
              {t("home.fluencyPath.subtitle")}
            </p>
          </div>

          <ol className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-8">
            {steps.map((step) => (
              <li key={step.number} className="border-t border-border pt-4">
                <div className="text-xs font-mono text-primary mb-2">
                  {step.number}
                </div>
                <h3 className="font-display text-lg font-semibold text-foreground mb-1">
                  {step.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {step.description}
                </p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default FluencyPath;
